// Moved verbatim from `src/hooks/query/useQueryOrganizationMembersSearch.ts`
// (now a shim). Key const lives in `../contracts` (frozen string); the API fn
// moved to `./api/organization` over the injected transport.

import { useQuery } from '@tanstack/react-query';
import { SEARCH_ORGANIZATION_MEMBERS } from '../../contracts';
import { searchOrganizationMembers } from '../api/organization';

export { SEARCH_ORGANIZATION_MEMBERS };

export function useQueryOrganizationMembersSearch(q: string, enabled = true) {
  return useQuery({
    queryKey: [SEARCH_ORGANIZATION_MEMBERS, q],
    queryFn: async () => {
      const { data } = await searchOrganizationMembers({ q, limit: 20 });
      return data;
    },
    enabled,
    staleTime: 60_000,
  });
}
